import {Repository} from "../../persistence/repository";
import {IssueStatus} from "../entities/issue-status.entity";
import {persistence} from "../../decorators/persistence.decorator";
import {singleton} from "tsyringe";

@singleton()
@persistence({
    entity: IssueStatus,
    preload: true
})
export class IssueStatusRepository extends Repository<IssueStatus> {

    public create(): Promise<IssueStatus | null> {
        return Promise.resolve(new IssueStatus());
    }

}